module.exports = __webpack_public_path__ + "img/bch.07648d53.png";